<template>
  <div style="background:#fff; padding:20px;">
    <div v-if="!currentEditorId">
        <div style="margin-bottom: 20px">
          <a-input v-model="query.name" placeholder="产品名称" style="width: 200px; margin-right: 10px" />
          <a-button type="primary" @click="loadData">查询</a-button>
          <a-button type="primary" icon="plus" style="margin-left: 10px" @click="handleCreate">新增产品</a-button>
        </div>

        <a-table :columns="columns" :data-source="data" rowKey="id" :loading="loading" :pagination="pagination" @change="handleTableChange">
          <span slot="status" slot-scope="text">
            <a-tag :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '上架' : '下架' }}</a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleDesign(record)">装修设计</a>
            <a-divider type="vertical" />
            <a @click="handleBaseInfo(record)">基本信息</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除吗?" @confirm="handleDelete(record.id)">
                <a style="color: red">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        
        <a-modal v-model="visible" title="产品信息" @ok="handleOk">
             <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-model-item label="名称"><a-input v-model="form.name" /></a-form-model-item>
                <a-form-model-item label="分类"><a-input v-model="form.category" /></a-form-model-item>
                <a-form-model-item label="状态"><a-switch :checked="form.status === 1" @change="val => form.status = val ? 1 : 0" /></a-form-model-item>
              </a-form-model>
        </a-modal>
    </div>

    <ProductEditor 
        v-else 
        :productId="currentEditorId" 
        @back="currentEditorId = null" 
    />
  </div>
</template>

<script>
import { getProductList, saveProduct, deleteProduct } from '@/api'
// 引入刚才创建的组件
import ProductEditor from './ProductEditor'

export default {
    components: { ProductEditor },
    data() {
        return {
            currentEditorId: null, // 控制是否显示编辑器
            query: { name: '' },
            data: [],
            loading: false,
            visible: false,
            form: {},
            pagination: { current: 1, pageSize: 10, total: 0 },
            columns: [
                { title: 'ID', dataIndex: 'id' },
                { title: '产品名称', dataIndex: 'name' },
                { title: '分类', dataIndex: 'category' },
                { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
                { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }
            ]
        }
    },
    created() { this.loadData() },
    methods: {
        loadData() {
            this.loading = true
            getProductList({ ...this.query, page: this.pagination.current }).then(res => {
                this.data = res.data.records;
                this.pagination.total = res.data.total;
                this.loading = false;
            })
        },
        handleTableChange(p) {
            this.pagination.current = p.current;
            this.loadData();
        },
        handleCreate() {
            this.form = { status: 1 };
            this.visible = true;
        },
        handleBaseInfo(record) {
            this.form = { ...record };
            this.visible = true;
        },
        handleOk() {
            saveProduct(this.form).then(() => {
                this.$message.success('保存成功');
                this.visible = false;
                this.loadData();
            })
        },
        handleDelete(id) {
            deleteProduct({ id }).then(() => {
                this.$message.success('删除成功');
                this.loadData();
            })
        },
        handleDesign(record) {
            this.currentEditorId = record.id;
        }
    }
}
</script>
